import { Col, Row, Tooltip } from 'antd';
import React, { ReactElement } from 'react';
import { useHistory } from 'react-router-dom';
import { GUTTOR_SPACE } from '../../constants/commonConstants';
import { ReactComponent as LeftArrowIcon } from '../../../assets/images/svg/i_left_arrow.svg';
import { ReactComponent as HisArrowIcon } from '../../../assets/images/svg/His_Back_Arrow.svg';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { ApplicationDetailModel } from '../../../store/models/applicationDetailModel';

const PageHeader = ({
  rightComponent: RightComponent, pageTitle, backUrl, titleRightButton,
  colSize, customeClass, footerComponent: FooterComponent, offsetClass,
  isPreAuthNewDesignEnabled, isNewadmission, id, isShowAdmissionForm,
  className, isHospitalSeal, isGrievance, isViewGrievancePage, isDeeplinkProcessed,
  ...args}: any): ReactElement => {
  const history = useHistory();
  const appDetail: ApplicationDetailModel = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail || {});

  const leftArrowClickHandler = (): void => {
    if (typeof(backUrl) === 'function') {
      backUrl();
    } else {
      if (backUrl === '/abdm/concent-list') {
        history.goBack();
      }
      history.push(backUrl);
    }
  };

  const pageTitleType = typeof(pageTitle);
  return (
    <div
      className={`${isPreAuthNewDesignEnabled ? 'new-design-tab-header' : isHospitalSeal ? 'tab-header-no-border' :
        isViewGrievancePage ? 'grievance-fixed-tab-header tab-header' : 'tab-header'}
    ${appDetail.getIsNewTpaDeskEnabled() && 'mb-20'}`}
    >
      <Row gutter={GUTTOR_SPACE} className={'align-center ' + (customeClass ? customeClass : '')}>
        {(pageTitle || backUrl) &&
          <Col md={colSize ? colSize : isViewGrievancePage ? 24 : 8} className="page-header-flex-content">
            {backUrl && <Tooltip title="Back">
              {isPreAuthNewDesignEnabled ?
                <HisArrowIcon
                  data-testid="back"
                  onClick={leftArrowClickHandler}
                  className="mr-10 fill-primary v-align-middle mouse-pointer"
                />
                : <LeftArrowIcon
                  data-testid="back"
                  onClick={leftArrowClickHandler}
                  className="mr-10 fill-primary v-align-middle mouse-pointer"
                />}
            </Tooltip>}
            {pageTitleType === 'string' ?
            <h1 className={`m-0 text-elipsis mr-10 page-title ${className}`} title={pageTitle}>{pageTitle}</h1> :
            <h1 className={`m-0 text-elipsis mr-10 ${className}`}>{pageTitle}</h1>
            }
                     {
                    titleRightButton &&

                     titleRightButton}

          </Col>
        }
        <Col md={(pageTitle || backUrl) ? (colSize ? 24 - colSize : (isPreAuthNewDesignEnabled && isNewadmission) ?
          id === 0 ? 8 : isShowAdmissionForm ? 16 : 8 : isGrievance ? 14 : 16) : 24}
          xxl={(pageTitle || backUrl) ? (colSize ? 24 - colSize : (isPreAuthNewDesignEnabled && isNewadmission) ?
            id === 0 ? 10 : 16 : 16) : 24}
          className={`header-right ${offsetClass && 'move-right'}`}>
          {
            RightComponent ?
              <RightComponent
                {...args}
                isDeeplinkProcessed={isDeeplinkProcessed}
              /> :
              null
          }
        </Col>
      </Row>
      {FooterComponent && <FooterComponent/>}
    </div>
  );
};

export default PageHeader;
